import { Observable, of } from 'rxjs';

export function getVersionData(): Observable<any[]> {
     return of([
          {
               id: 9,
               version: "2.0",
               releaseDate: "February 27, 2025",
               descriptionShown: false,
               isNew: true,
               beta: true,
               description: `This version serves as the official release of the Logbook 2.0 
               in our efforts to replace the current SAS Interactive Logbook.  Although the 
               SAS Interactive Logbook will remain live to allow pilots to export their 
               logbook until this feature is available in Logbook 2.0.  Also in this version, 
               the most prominent update is to the Flight Details view, where aircraft 
               registrations are now accessible. Tapping or clicking on the registration 
               number will initiate a popup displaying further details about the aircraft. 
               Additionally, a tag has been added to the Sequence Details view, indicating 
               the 'Add Reason Code' for each sequence. Tapping or selecting the code will 
               reveal a popup defining the code. Furthermore, for deadhead flights, an 
               additional tag has been placed beside the DH flag, specifying the airline where 
               the deadhead occurred. This information will enhance the identification of 
               flights conducted by airlines other than American Airlines' mainline. By 
               providing this data, pilots can gain a better understanding of why the actual 
               flight times are not displayed, as American Airlines does not receive this 
               information.  In addition, this update also includes the implementation of daily 
               updates to the Logbook, with data delayed by 8 days.  As we move forward 
               a future enhancement will be implemented to provide near real-time updates.  
               Also in this version are bug fixes and performance updates.`,
               features: [
                    "Daily updates to the Logbook, with data delayed by 8 days",
                    "Aircraft Registrations added to each flight detail",
                    "Add Reason Code flag added to each sequence detail",
                    "Additional flag added for Deadhead flight indicating the airline code"
               ],
               fixes: [
                    "Application perfomance and efficiency updates",
                    "Update version control algorithm to account for new versioning system",
                    "Relocated call to check for new version to the app component to ensure the check is made on app load",
                    "Added a close button to side bar navigation when used on smaller devices, button is hidden when viewed on larger devices.",
                    "Updated Flight Details block times to account for rescheduled (departure OR arrival), and (departure AND  arrival) times",
                    "Time by Aircraft updated to address NA types",
                    "FAQ's updated to reflect possible NA aircraft types, although a correction in TASC appears to have corrected any possible NA types that were mis-identified as deadheads",
                    "Add controls to Search, numeric fields to show numeric keyboard only on mobile devices",
                    "Refactoring of backend data to account for deadheads, aircraft types and HSS cross referencing of flights to ensure correct order of actual"
               ]
          },
          {
               id: 8,
               version: "0.5.0",
               releaseDate: "February 1, 2025",
               descriptionShown: false,
               isNew: false,
               beta: true,
               description: "Upadate the Search feature to include searching by Airport or Route ",
               features: [
                    "Search by airport or route added to the Search form"
               ],
               fixes: [
                    "Minor bug fixes and performance updates"
               ]
          },
          {
               id: 7,
               version: "0.4.8",
               releaseDate: "January 23, 2025",
               descriptionShown: false,
               isNew: false,
               beta: true,
               description: "Upadate the Search feature to include searching by Airport or Route ",
               features: [
                    "Search by airport or route added to the Search form"
               ],
               fixes: [
                    "Minor bug fixes and performance updates"
               ]
          },
          {
               id: 6,
               version: "0.4.6",
               releaseDate: "January 20, 2025",
               descriptionShown: false,
               isNew: false,
               beta: true,
               description: "Bug fixes and performance updates.",
               features: [
                    "No new features in this release"
               ],
               fixes: [
                    "Application perfomance and efficiency updates",
                    "Fixed Time by Aircraft Variant chart to display correct tooltip data",
                    "Various UI styling updates"
               ]
          },
          {
               id: 5,
               version: "0.4.5",
               releaseDate: "January 15, 2025",
               descriptionShown: false,
               isNew: false,
               beta: true,
               description: "This update introduces the new feature “Time by Aircraft” chart to the Analyze view. The search form has been enhanced for improved performance and the capability to search for historical aircraft. Additionally, the Flight Totals on the Flights Table View have been updated to reflect changes as users navigate through different months and years.",
               features: [
                    "Time by Aircraft chart added to the Analyze view.",
                    "Flight Totals, Table View and Calendar View are now in sync with dynamically updated totals"
               ],
               fixes: [
                    "Updated search logic performance",
                    "Updated search form Equipment field dropdown to include historical aircraft and a dropdown filter",
                    "Several backend API and database updates for performance and data accuracy",
                    "Table View flight list will now remember scroll position when navigating back to the view",
                    "Legal disclaimer information added but temporarily disabled until further notice",
                    "Updated Flight list and flight details to validate and remove an aircraft ID of null or 'N' only"
               ]
          },
          {
               id: 4,
               version: "0.4.4",
               releaseDate: "January 13, 2025",
               descriptionShown: false,
               isNew: false,
               beta: true,
               description: "In this release, we have enhanced the Flights Table view to enable users to sort flights by date in ascending or descending order. Additionally, we have introduced an Admin view specifically designed for administrators to monitor data issues and server status.  One of the most significant improvements is the Calendar view, which now accurately displays flight sequences on the correct day. Previously, sequences starting before 5:00 a.m. would appear with a start date on the previous day.  Furthermore, we have implemented the Time by Aircraft chart, which provides a visual representation of total flight time per aircraft type. Selecting a wedge on the chart will reveal the time breakdown by variant of that aircraft type.  Lastly, the Flight Totals feature has been enhanced to dynamically update flight totals while navigating through years and months. Additionally, the Table View and Calendar View remain synchronized to ensure accurate and up-to-date information.  We have also implemented various user interface enhancements and bug fixes to improve the overall user experience.",
               features: [
                    "Added the ability for users to sort flights by date ascending or descending.",
                    "Added new Admin view for Administrators only to review data issues and server status."
               ],
               fixes: [
                    "Updated crew member details API call logic for improved performance",
                    "Fixed an issue for Calendar where sequences would display one day prior to the actual start day",
                    "Corrected position and size of dialog popups across several views for mobile devices in landscape mode",
                    "Known issues updated to reflect current status",
                    "Spelling corrections to FAQ's and Version Details sections",
                    "Moved Flights Table refresh button to the left of the Last Updated label for clarity",
                    "Updated UI colors and layout for all views to be more consistent",
                    "Updated Calendar view to display the Holiday Pay Legend where the legend was not visible when navigating back to the Calendar view from the Flights Table view",
                    "Corrected average label calculation on Flight Time by Month chart to account for a 12 month period instead of number of months flown",
                    "Flight List item will now display only one timing based on user selected time format",
                    "Updated charts api to check for loading status before rendering chart",
                    "Updated logic for theme service and theme toggle button for light/dark mode to respond on first click",
                    "Updated various help icons with detail information pertaining to the view",
                    "Added a toolbar to the Calendar view containing a refresh button, last updated label and information button"
               ]
          },
          {
               id: 3,
               version: "0.3.10",
               releaseDate: "December 17, 2024",
               descriptionShown: false,
               isNew: false,
               beta: true,
               description: "In this release we have updated the About view and all Flight Totals.  The About view will allow users to better track version changes, known issues and version control.  A Frequently Asked Question section was added to help users with questions they may have on using the app.  We have also made some UI changes and bug fixes.",
               features: [
                    "Updated the About section to include Version Details (Future features, Known Issues & Versions), Feedback form and a FAQ section.",
                    "Update Flight Totals with changes made on the server reflected on the Flights View and Analyze View"
               ],
               fixes: [
                    "Analyze view UI colors and layout redesign",
                    "Increased min-width screen restriction when viewing Flight or Sequence details in landscape mode for mobile devices",
                    "Sequence Detail flight list corrected to be listed in descending order from most recent date to earlier date.  An option to change to ascending to descending coming soon.",
                    "Update side bar navigation logic to correct issue where multiple items would show selected when rotating the device.",
                    "Updated Flights Table view filter icons on toolbar to reflect changes made from the Filter Flights Dialog when there are 'No Flights Found' displayed on the flight list",
                    "Updated error handline and logging for better tracking of errors",
                    "Updated charts Time by Seat chart information box at the bottom for clarity on seat position and hours",
                    "Spelling corrections",
                    "Updated Analyze - Flight Totals total time to use number separator for larger values",
                    "Update all calendar views to adjust size and translate position to account for the top navigation bar that is not visible in the mobile app",
                    "Added a close button to side bar navigation when used on smaller devices, button is hidden when viewed on larger devices.",
                    "Added mask behind sidebar navigation menu to allow tapping outside navigation bar to close."
               ]
          },
          {
               id: 2,
               version: "0.3.9",
               releaseDate: "November 30, 2024",
               descriptionShown: false,
               isNew: false,
               beta: true,
               description: "In this release there were extensive changes made to the layout and navigation of the app.  The app was refactored to be more responsive on mobile devices and the browser navigation bar was added and corrected for displaying in the correct location and size.",
               features: [
                    "App refactored to be more responsive on mobile devices.",
                    "Browser navigation bar added and corrected for displaying in the correct location and size."
               ],
               fixes: [
                    "Complete refactoring of the app navigation to be more responsive on mobile devices and tablets.",
                    "Search form validation was updated to allow for more accurate search results.",
                    "Search results view updated to allow for multiple pages of search results."
               ]
          },
          {
               id: 1,
               version: "0.1.6",
               releaseDate: "November 18, 2024",
               descriptionShown: false,
               isNew: false,
               beta: true,
               description: "This is the initial release of the Logbook App.  Initially the primary goal is to validate pilot flight data and provide a way to view and analyze that data.  The app will be updated with new features and bug fixes as they are developed.",
               features: [
                    "Flights View - View all flights in a table format or in a calendar view.",
                    "Analyze View - View charts and data for your flights.",
                    "Search - Search for flights by date, aircraft, or sequence.",
                    "Flight Detail - View detailed information about a flight.",
                    "Sequence Detail - View detailed information about a sequence.",
                    "About - View information about the app and send feedback."
               ],
               fixes: [
                    "Multiple navigation bug fixes",
                    "Flight List interface bug fixes",
                    "Chart fixes and interface enhancements",
                    "Search bug fixes and validation",
                    "Sequence Detail bug fixes"
               ]
          }
     ]);
}